import { jsx as c, jsxs as b } from "react/jsx-runtime";
import { c as m } from "./index-65016bfa.mjs";
import s, { css as l } from "styled-components";
import "@fcamna/shared-component-foundations";
import { useState as R, useRef as T, useEffect as L } from "react";
import { u as G } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { AspectRatio as D } from "./aspectRatio.js";
import { Icon as j } from "./icon.js";
import { Image as q } from "./image.js";
import { I as E, H as A } from "./helperText-d9646f54.mjs";
import { L as H } from "./label-33699561.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import { u as O } from "./uniqueId-321287e8.mjs";
import { S as z } from "./screenReaderOnly-fd82ed96.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "@fcamna/shared-icons";
import "./mediaDisclosureButton.js";
import "./popupTip.js";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./closeButton.js";
import "./iconButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
const F = s.div`
  &.SelectionsBase {
    ${({
  theme: {
    components: { selectionCard: e },
    componentStyles: t
  }
}) => l(e.SelectionsBase, t)};
  }
`, v = ({ selected: e = !1, disabled: t = !1, children: i, isInvalid: o, ...n }) => /* @__PURE__ */ c(
  F,
  {
    tabIndex: 0,
    className: m([
      n == null ? void 0 : n.className,
      "SelectionsBase",
      {
        "SelectionsBase--disabled": t,
        "SelectionsBase--selected": !t && !o && e,
        "SelectionsBase--invalid": !t && o
      }
    ]),
    ...n,
    children: i
  }
), k = s.div`
  &.SelectionCard {
    ${({
  theme: {
    components: { selectionCard: e },
    componentStyles: t
  }
}) => l(e.SelectionCard, t)};
  }
`, Q = s.h1`
  &.SelectionCard__title {
    ${({
  theme: {
    components: { selectionCard: e }
  }
}) => l(e.Title)};
  }
`, X = s.p`
  &.SelectionCard__description {
    ${({
  theme: {
    components: { selectionCard: e }
  }
}) => l(e.Description)};
  }
`, J = s(D)`
  &.SelectionCard__media {
    ${({
  theme: {
    components: { selectionCard: e }
  }
}) => l(e.Media)};
  }
`, U = s.div`
  &.SelectionCard__body {
    ${({
  theme: {
    components: { selectionCard: e }
  }
}) => l(e.Body)};
  }
`, V = s.div`
  &.IconContainer {
    ${({
  theme: {
    components: { selectionCard: e }
  }
}) => l(e.IconContainer)};
  }
`, Y = s.div`
  &.TrailingElementWrapper {
    ${({
  theme: {
    components: { selectionCard: e }
  }
}) => l(e.TrailingElementWrapper)};
  }
`, je = ({
  selected: e = !1,
  disabled: t = !1,
  alignContents: i = "center",
  media: o,
  titleProp: n,
  description: N,
  trailingElement: r,
  children: p = r,
  className: h,
  onKeyDown: f,
  onClick: d,
  ...B
}) => {
  var y, S, u, I, $;
  const g = G({ label: "Selection Card" });
  return /* @__PURE__ */ c(
    v,
    {
      disabled: t,
      selected: e,
      onClick: (a) => {
        t || d(a);
      },
      onKeyDown: (a) => {
        !t && (f == null || f(a)), (a.key === "Enter" || a.key === " ") && (a.preventDefault(), !t && (d == null || d(a)));
      },
      ...g,
      ...B,
      children: /* @__PURE__ */ b(
        k,
        {
          className: m([
            "SelectionCard",
            `SelectionCard--${i}Aligned`,
            {
              "SelectionCard--disabled": t,
              "SelectionCard--selected": !t && e,
              "SelectionCard--imageContainer": ((y = o == null ? void 0 : o.imageProp) == null ? void 0 : y.ratio) !== "2/1"
            },
            h
          ]),
          children: [
            (o == null ? void 0 : o.imageProp) && /* @__PURE__ */ c(
              J,
              {
                ratio: o.imageProp.ratio || "1/1",
                objectFit: "cover",
                className: m([
                  "SelectionCard__media",
                  !o.imageProp.ratio || o.imageProp.ratio === "1/1" ? "SelectionCard__media--fixed-container" : "SelectionCard__media--with-radius"
                ]),
                children: /* @__PURE__ */ c(
                  q,
                  {
                    src: o.imageProp.src,
                    alt: o.imageProp.alt
                  }
                )
              }
            ),
            /* @__PURE__ */ b(
              U,
              {
                className: m([
                  "SelectionCard__body",
                  {
                    "SelectionCard__body--disabled": t
                  },
                  `SelectionCard__body--${i}Aligned`
                ]),
                children: [
                  o != null && o.iconProp && typeof ((S = o.iconProp) == null ? void 0 : S.element) == "string" ? /* @__PURE__ */ c(
                    j,
                    {
                      name: (u = o.iconProp) == null ? void 0 : u.element,
                      size: "xxl",
                      extended: !0
                    }
                  ) : ((I = o == null ? void 0 : o.iconProp) == null ? void 0 : I.element) && /* @__PURE__ */ c(V, { className: m(["IconContainer--xxLarge"]), children: ($ = o == null ? void 0 : o.iconProp) == null ? void 0 : $.element }),
                  n && /* @__PURE__ */ c(
                    Q,
                    {
                      as: (n == null ? void 0 : n.headingLevel) || "h1",
                      className: m(["SelectionCard__title", { "SelectionCard__title--xlarge": (n == null ? void 0 : n.titleSize) === "xLarge" }]),
                      children: n == null ? void 0 : n.title
                    }
                  ),
                  N && /* @__PURE__ */ c(X, { className: "SelectionCard__description", children: N }),
                  p && /* @__PURE__ */ c(Y, { className: m("TrailingElementWrapper"), children: p })
                ]
              }
            )
          ]
        }
      )
    }
  );
}, Z = s.div`
  &.SelectionTileCompact {
    ${({
  theme: {
    components: { selectionTileCompact: e },
    componentStyles: t
  }
}) => l(e.SelectionTileCompact, t)};
  }
`, w = ({ children: e, selected: t, disabled: i, isInvalid: o, ...n }) => /* @__PURE__ */ b(
  v,
  {
    disabled: i,
    isInvalid: o,
    selected: t,
    "aria-invalid": o,
    "aria-disabled": i,
    ...n,
    children: [
      /* @__PURE__ */ c(
        Z,
        {
          className: m([
            "SelectionTileCompact",
            {
              "SelectionTileCompact--disabled": i
            }
          ]),
          children: e.toString().slice(0, 4)
        }
      ),
      /* @__PURE__ */ c(
        z,
        {
          "aria-live": "polite",
          id: "hidden_message_id",
          children: t ? "Selected" : ""
        }
      )
    ]
  }
), K = "SelectionTileCompactGroup", x = s.div`
  &.SelectionTileCompactGroup-Wrapper {
    ${({
  theme: {
    components: { selectionTileCompact: e },
    componentStyles: t
  }
}) => l(e.SelectionTileCompactGroup, t)};
  }
`, P = s.div`
  &.SelectionTileCompactGroup__MainWrapper {
    ${({
  theme: {
    components: { selectionTileCompact: e }
  }
}) => l(e.MainWrapper)};
  }
`, qe = ({
  tiles: e,
  selectedTile: t,
  onSelect: i,
  labelProp: o,
  infoProp: n,
  trailingText: N,
  helperTextProp: r,
  inputState: p,
  ...h
}) => {
  var I, $;
  const [f, d] = R(t), B = G({ label: "Selection Tile Compact Group" }), g = T(O(K)), y = `${g.current}_label_id`, S = {
    defaultId: ((I = r == null ? void 0 : r.defaultProp) == null ? void 0 : I.id) || `default_${g.current}_message_id`,
    secondaryId: (($ = r == null ? void 0 : r.secondaryProp) == null ? void 0 : $.id) || `secondary_${g.current}_message_id`
  };
  L(() => {
    d(t);
  }, [t]);
  const u = (a, _) => {
    !e[_].disabled && _ !== t && (i == null || i(a, _), d(_));
  };
  return /* @__PURE__ */ b(
    P,
    {
      className: m(["SelectionTileCompactGroup__MainWrapper"]),
      ...B,
      "aria-labelledby": `${y} ${S.defaultId} ${S.secondaryId}`,
      ...h,
      children: [
        /* @__PURE__ */ c(
          H,
          {
            labelProp: { ...o, id: y },
            infoProp: {
              infoText: "",
              infoType: "tooltip",
              popupTipHeader: "Info",
              ...n
            },
            trailingText: N
          }
        ),
        /* @__PURE__ */ c(x, { className: m(["SelectionTileCompactGroup-Wrapper"]), children: e.map(({ label: a, disabled: _, ...M }, W) => /* @__PURE__ */ c(
          w,
          {
            disabled: _,
            ...M,
            selected: f === W,
            onClick: (C) => {
              u(C, W);
            },
            onKeyDown: (C) => {
              (C.key === "Enter" || C.key === " ") && (C.preventDefault(), u == null || u(C, W));
            },
            isInvalid: p === E.ERROR,
            children: a
          },
          W
        )) }),
        /* @__PURE__ */ c(
          A,
          {
            defaultProp: { id: S.defaultId, ...(r == null ? void 0 : r.defaultProp) || { helperText: "" } },
            secondaryProp: p && p !== E.NONE ? { ...r == null ? void 0 : r.secondaryProp, state: p, id: S.secondaryId } : void 0
          }
        )
      ]
    }
  );
};
export {
  je as SelectionCard,
  qe as SelectionTileCompactGroup
};
